<template>
  <v-navigation-drawer
    v-model="isOpen"
    right
    app
    temporary
    width="340"
    class="pa-3"
    ref="drawerContent"
  >
    <v-toolbar flat dense>
      <v-toolbar-title>Notifications</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="isOpen = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>

    <v-divider class="mb-2" />

    <v-list dense>
        <div
          v-for="notification in notifications"
          :key="notification.notification_id"
        >
          <notification-list-item
            :notification="notification"
            @mark-read="onItemMarkRead"
            @clicked="onItemClick"
            @delete="onItemDelete"
          />

          <v-divider></v-divider>
        </div>
    </v-list>

    <v-alert v-if="notifications.length === 0" type="info" dense text>
      No notifications yet.
    </v-alert>

    <!--  START Testing inputs  -->

    <div v-if="canSendMock" class="mt-3">
      <v-select
        v-model="notificationType"
        :items="['redirect', 'message', 'maintenance']"
        label="Notification Type"
        dense
      />

      <v-text-field
        v-if="notificationType !== 'maintenance'"
        v-model="testUserId"
        label="Target User ID"
        type="number"
        dense
      />

      <v-text-field
        v-if="notificationType !== 'maintenance'"
        v-model="customTitle"
        label="Title"
        type="text"
        dense
      />

      <v-text-field
        v-if="notificationType !== 'maintenance'"
        v-model="customBody"
        label="Body"
        type="text"
        dense
      />

      <v-select
        v-model="customStyle"
        :items="['info', 'warning']"
        label="Style"
        dense
      />

      <!--  START REDIRECT inputs  -->
      <v-text-field
        v-if="notificationType === 'redirect'"
        v-model="customURL"
        label="URL"
        hint="/application/AppId/Section, Eg: /application/351337/documents"
        persistent-hint
        type="text"
        dense
      />
      <!--  END REDIRECT inputs  -->

      <!--  START MESSAGE && Maintenance inputs  -->
      <v-text-field
        v-if="notificationType === 'message' || notificationType === 'maintenance'"
        v-model="messageTitle"
        label="Message Title"
        type="text"
        dense
      />

      <v-text-field
        v-if="notificationType === 'message' || notificationType === 'maintenance'"
        v-model="messageText"
        label="Message Text"
        type="text"
        dense
      />

      <!--  START MESSAGE inputs  -->
      <v-switch
        v-if="notificationType === 'message'"
        v-model="isMessageMandatory"
        label="Is Message Mandatory?"
        dense
      />
      <!--  END MESSAGE inputs  -->


      <!--  START Maintenance inputs  -->
      <v-switch
        v-if="notificationType === 'maintenance'"
        v-model="isMaintenanceForce"
        label="Maintenance Force"
        dense
      />
      
      <!--  START Component inputs  -->
      <!-- <v-select
        v-if="notificationType === 'component'"
        v-model="componentTarget"
        :items="['Loan', 'Applicant']"
        label="Component Target"
        dense
      />
      <v-text-field
        v-if="componentTarget === 'Loan' && notificationType === 'component'"
        v-model="componentTargetId"
        label="Target Loan ID"
        type="text"
        dense
      />
      
      <v-select
        v-if="notificationType === 'component'"
        v-model="componentName"
        :items="['UploadDocuments', 'VedaSummary']"
        label="Component Name"
        dense
      /> -->

      <!--  END MESSAGE inputs  -->

      <v-btn
        color="primary"
        @click="sendTestNotification"
        class="mt-2"
        block
      >
        Send Mock Notification
      </v-btn>
    </div>
    <!--  END Testing inputs  -->

    <!-- <v-divider class="my-2" />

    
    <div class="text-right">
      <v-btn small text color="primary" @click="markAllRead">
        Mark all as read
      </v-btn>
    </div> -->
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapActions, mapGetters} from 'vuex';
import NotificationListItem from './NotificationListItem.vue';

export default {
  name: 'NotificationSidebar',
  components: { NotificationListItem },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    testUserId: null,
    isOpen: false,
    notificationType: 'message',
    customTitle: '',
    customBody: '',
    customURL: '',
    customStyle: '',
    isMessageMandatory: false,
    messageTitle: '',
    messageText: '',
    isMaintenanceForce: false,
    loadingMore: false,
    // componentName: '',
    // componentTarget: '', // 'Loan' | 'Applicant'
    // componentTargetId: '', // loan ID or other
    // componentDataProps: {},  
  }),
  watch: {
    value(val) {
      console.log('[Sidebar] Prop value changed:', val);
      this.isOpen = val;
    },
    isOpen(val) {
      console.log('[Sidebar] Emitting input back to parent:', val);
      this.$emit('input', val); // for v-model to work in Vue 2
      if (val) {
        this.markSeen();
      }
    },
    list(val) {
      console.log('[list] Updated ', val);
    },
  },
  computed: {
    ...mapState('notifications', ['list','hasMore', 'currentPage']),
    ...mapGetters('notifications', ['canSendMock']),
    ...mapGetters({
      user: 'user'
    }),
    notifications() {
      return [...this.list];
    },
  },
  methods: {
    ...mapActions('notifications', ['markAllRead', 'markRead', 'delete']),
    onItemClick(notification) {
      console.log('[Sidebar] Notification clicked:', notification);
      if (notification.notification_type === 'redirect') {
        this.markRead(notification.notification_id);
        this.$router.push(notification.data.redirect.url || '/');
      } else {
        this.$root.$emit('trigger-popup', notification);
      }
    },
    onItemDelete(notification) {
      this.delete(notification.notification_id);
    },
    onItemMarkRead(notification) {
      this.markRead(notification.notification_id);
    },
    async markSeen() {
      await this.$store.dispatch('notifications/markSeen');
    },
    async handleScroll(e) {
      const el = e.target;
      if (
        el.scrollTop + el.clientHeight >= el.scrollHeight - 50 &&
        this.hasMore &&
        !this.loadingMore
      ) {
        this.loadingMore = true;
        await this.$store.dispatch('notifications/fetch', this.currentPage + 1);
        this.loadingMore = false;
      }
   },
   async sendTestNotification() {
      const payload = {
        user_id: this.testUserId,
        title: this.customTitle,
        body: this.customBody,
        notification_type: this.notificationType,
        style: this.customStyle || 'info',
        data: {
          redirect: {
            url: this.customURL || null,
          },
          message: {
            title: this.messageTitle || '',
            text: this.messageText || '',
            mandatory: this.isMessageMandatory || false,
          },
          maintenance: {
            title: this.messageTitle || '',
            text: this.messageText || '',
            url: this.customURL || null,
            is_maintenance_force: this.isMaintenanceForce
          }
          // component: {
          //   name: this.componentName || '',
          //   props: this.componentDataProps || {},
          // }
        }
      };
      await this.$store.dispatch('notifications/sendMockNotification', payload);
    }
  },
  mounted() {
    this.$store.dispatch('notifications/checkMockNotificationPermission');
    this.isOpen = this.value;
    this.$nextTick(() => {
      const el = this.$refs.drawerContent?.$el || this.$refs.drawerContent;
      // Traverse to find the actual scroll container inside the drawer
      const scrollEl = el?.querySelector('.v-navigation-drawer__content');
      if (scrollEl) {
        scrollEl.addEventListener('scroll', this.handleScroll);
      }
    });
  },
  beforeDestroy() {
    const el = this.$refs.drawerContent?.$el || this.$refs.drawerContent;
    if (el) {
      el.removeEventListener('scroll', this.handleScroll);
    }
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: all 0.4s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style>
